import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { css } from "styled-components";

cartLineQuantityStyles.editableQuantityTextField = {
    cssOverrides: {
        inputSelect: css`
            -moz-appearance: textfield;
        `,
    },
};
